import { createStore, Store } from 'vuex'
import type { InjectionKey } from 'vue'
import type { State } from '@/types/store/state.ts'
import VuexORM from '@vuex-orm/core'

import { User, School, News, Channel } from '@/store/models/index.js'
import state from './state.ts'
import modules from './modules/index.js'
import mutations from './mutations.js'
import actions from './actions.js'

import {
  Course,
  Lesson,
  Subject,
  Grade,
  Bookable,
  Holiday,
  Unit,
  Teacher,
  Absence,
  Time,
  AbsenceType,
  Substitution,
  Pattern,
  TimetableMeta
} from 'src/store/models/timetable/index.js'

import {
  LessonBookable,
  LessonTeacher,
  LessonGrade,
  UserParent,
  UserCourse,
  NewsChannel,
  UserChannel,
  SubstitutedLesson,
  FileParent,
  TeacherSubject,
  SubjectBookable
} from 'src/store/models/pivot/index.js'

import { CalendarEvent, Chat, Cloud, File, Message } from 'src/store/models/channel/index.js'
import { SchoolLink } from 'src/store/models/misc/index.js'

const database = new VuexORM.Database()
database.register(Course)
database.register(User)
database.register(UserParent)
database.register(School)
database.register(NewsChannel)
database.register(News)
database.register(Channel)
database.register(Lesson)
database.register(Subject)
database.register(Grade)
database.register(LessonGrade)
database.register(Bookable)
database.register(Holiday)
database.register(LessonBookable)
database.register(Unit)
database.register(LessonTeacher)
database.register(Teacher)
database.register(Absence)
database.register(AbsenceType)
database.register(Time)
database.register(UserCourse)
database.register(Substitution)
database.register(SubstitutedLesson)

database.register(UserChannel)
database.register(Chat)
database.register(Cloud)
database.register(File)
database.register(Message)
database.register(FileParent)
database.register(TeacherSubject)
database.register(SubjectBookable)
database.register(Pattern)
database.register(TimetableMeta)
database.register(SchoolLink)
database.register(CalendarEvent)

export const key: InjectionKey<Store<State>> = Symbol()

const store = createStore<State>({
  plugins: [VuexORM.install(database)],
  state,
  actions,
  mutations,
  modules,
  strict: true,
})

// this only affects Cypress tests - setting store on the window object enables us to
// use it in cypress tests which is nice
if (window.Cypress) {
  // @ts-expect-error: Cypress is only available in test environment and window.__store__ is used for testing purposes
  window.__store__ = store
}

export default store
